import React from 'react'
import Header from '../Components/Header'
import TestComponent from '../Components/Assessment/Testarea/TestComponent'

const Assessment = () => {
  return (
    <div>
      <Header/>
      <TestComponent/>
    </div>
  )
}

export default Assessment
